import { NavLink } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

export const Link = styled(NavLink)`
  display: block;
  overflow: visible;
`;
